var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "footer",
    { staticClass: "auth-footer auth-text" },
    [
      _vm._v("\n  Copyright © 2023 "),
      _c("strong", [_vm._v(_vm._s(_vm.appName))]),
      _vm._v(". All rights reserved - v1.1.29\n  "),
      _c("br"),
      _vm._v("\n  Developed with\n  "),
      _c("b-icon", { attrs: { color: "red", icon: "heart-fill" } }),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "text-reset fw-bold",
          attrs: {
            href: "/#",
            target: "_blank",
            title: "PT. Nash Interaksi Semesta",
          },
        },
        [_vm._v("PT. Nash Interaksi Semesta")]
      ),
      _vm._v("\n  Powered by KJS MARI\n"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }